import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { CLAIMS_INIT_LOADING, CLAIMS_INIT_SUCCESS, CLAIMS_INIT_FAIL, CLAIMS_CLAIMENTRY_INIT_LOADING, CLAIMS_CLAIMENTRY_INIT_SUCCESS, CLAIMS_CLAIMENTRY_INIT_FAIL, CLAIMS_CLAIMDETAIL_INIT_LOADING, CLAIMS_CLAIMDETAIL_INIT_SUCCESS, CLAIMS_CLAIMDETAIL_INIT_FAIL, CLAIMS_CLAIMDETAIL_RESERVE, CLAIMS_CLAIMDETAIL_PARAM_RESERVE, CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL, CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING } from '@/store/types'

export const general = {
  async claimsInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.claims
    if (apiUrl) {
      commit(CLAIMS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(CLAIMS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLAIMS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async claimEntryInit({ commit, state }) {
    const apiUrl = state.menu.claimEntry
    if (apiUrl) {
      commit(CLAIMS_CLAIMENTRY_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CLAIMS_CLAIMENTRY_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMS_CLAIMENTRY_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLAIMS_CLAIMENTRY_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async claimDetailInit({ commit, state }) {
    let apiUrl = state.claimEntry.menu.claimDetail
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CLAIMS_CLAIMDETAIL_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          // param listing if any
        }
      } catch (error) {
        commit(CLAIMS_CLAIMDETAIL_INIT_FAIL)
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async claimReserve({ commit, state }, { busCls, toDefault = true }) {
    const expand = {
      busCls: busCls
    }
    let apiUrl = state.claimDetail.menu.reserve
    if (apiUrl) {
      apiUrl = expandURI(state.claimDetail.menu.reserve, expand)
      try {
        commit(CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING)
        const result = await http.get(apiUrl)
        const { data } = result
        if (data.hasContent) {
          commit(CLAIMS_CLAIMDETAIL_PARAM_RESERVE, data.data)

          // For Reserve, we have to check (def && non addable) 1st (as this value is fixed)
          // Then we check existing value
          // Finally add those def && addable
          const hasInited = state.claimDetail.claimForm.clmReserves && state.claimDetail.claimForm.clmReserves.length > 0
          if (state.claimDetail.claimParam && state.claimDetail.claimParam.reserve.length > 0) {
            const commitReserve = []
            for (let reserveParam of state.claimDetail.claimParam.reserve) {
              // Check existing
              let exist = false
              if (state.claimDetail.claimForm.reserve && state.claimDetail.claimForm.reserve.length > 0) {
                for (let reserveForm of state.claimDetail.claimForm.reserve) {
                  if (reserveForm.key === reserveParam.value) {
                    commitReserve.push(reserveForm)
                    exist = true
                    break
                  }
                }
              }
              if (!exist && !hasInited && toDefault) {
                commitReserve.push({
                  key: reserveParam.value,
                  value: 0,
                  label: reserveParam.value + ' - ' + reserveParam.label
                })
              }
            }
            commit(CLAIMS_CLAIMDETAIL_RESERVE, commitReserve)
          } else {
            commit(CLAIMS_CLAIMDETAIL_RESERVE, [])
          }
        } else {
          commit(CLAIMS_CLAIMDETAIL_PARAM_RESERVE, [])
        }
      } catch (error) {
        console.log(error)
        commit(CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL)
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL)
    }
  }
}
